import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3ii405yp: FaireBrandEntity = {
  token: "b_3ii405yp",
  type: "brand",
  name: "Lillian Rose",
  avatarUrl:
    "https://cdn.faire.com/fastly/082cccbc3d7581dc9169b2f8438e160824a17e6d37a5584c2186fb5d197c53ea.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f959a29982a443ebb138cc029b87578c799872482c318eba08d2a9e61c31b880.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/082cccbc3d7581dc9169b2f8438e160824a17e6d37a5584c2186fb5d197c53ea.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f959a29982a443ebb138cc029b87578c799872482c318eba08d2a9e61c31b880.jpeg",
  location: "Ontario, CA, USA",
  minimumOrderDollars: 137,
  rating: 4.9,
  reviewCount: 142,
  isTopShop: true,
  isInsider: true,
  description:
    "Lillian Rose is a leader in the Wedding, Baby and Gift industry for over 30 years, Through a spectacular variety of gift, accessory, and décor items. Lillian Rose strives to offer exceptional customer service and quality products to capture life’s most unforgettable moments. Creating top trending items for every special moment in life and gift giving opportunity.",
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:44:59.943Z",
    importedBy: "entity-db-cli",
  },
};
